import { format } from 'date-fns';

export const formatRangeTanggal = (startDate, endDate, locale) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (start.getFullYear() !== end.getFullYear()) {
    // Tahun beda
    return `${format(start, 'dd MMM yyyy', { locale })} - ${format(end, 'dd MMM yyyy', { locale })}`;
  } else if (start.getMonth() === end.getMonth()) {
    // Bulan sama di tahun yang sama
    return `${format(start, 'dd', { locale })} - ${format(end, 'dd MMM yyyy', { locale })}`;
  } else {
    // Bulan beda tapi tahun sama
    return `${format(start, 'dd MMM', { locale })} - ${format(end, 'dd MMM yyyy', { locale })}`;
  }
}